import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLightbulb, faClock, faPalette, faGift, faStar, faFire, faMask } from '@fortawesome/free-solid-svg-icons';

// Map emoji icons to FontAwesome icons
const iconMap = {
  '💡': faLightbulb,
  '⏰': faClock,
  '🎨': faPalette,
  '🎉': faGift,
  '🕎': faStar, // Menorah - using star as alternative
  '🕯️': faFire, // Candle - using fire as alternative
  '✨': faStar, // Sparkles - using star as alternative
};

export default function AIStarterCard({ starter }) {
  const handleClick = () => {
    window.dispatchEvent(new CustomEvent('chatInput', { 
      detail: { message: starter.prompt, experience: starter.experienceId ? { id: starter.experienceId } : null } 
    }));
  };

  return (
    <motion.div
      whileHover={{ y: -6 }}
      transition={{ duration: 0.2 }}
      onClick={handleClick}
      className="group bg-gradient-to-br from-primary/5 to-accent/5 rounded-2xl border border-primary/20 overflow-hidden cursor-pointer shadow-sm hover:shadow-xl transition-all duration-300"
    >
      <div className="p-5">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
            {iconMap[starter.icon] ? (
              <FontAwesomeIcon icon={iconMap[starter.icon]} className="text-primary text-2xl" />
            ) : (
              <FontAwesomeIcon icon={faLightbulb} className="text-primary text-2xl" />
            )}
          </div>
          <div className="flex-1 min-w-0">
            <span className="text-xs font-semibold text-primary uppercase tracking-wide mb-2 block">AI Starter</span>
            <p className="text-sm text-text-primary font-medium line-clamp-3">
              {starter.prompt}
            </p>
          </div>
        </div>
        
        <div className="flex items-center justify-end mt-4">
          <span className="text-sm font-semibold text-primary opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1">
            Start chat
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </span>
        </div>
      </div>
    </motion.div>
  );
}

